import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__ from "@radix-ui/react-label";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const labelVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70');
const Label = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...properties }, reference)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__.Root, {
        ref: reference,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)(labelVariants(), className),
        ...properties
    }));
Label.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__.Root.displayName;
export { Label };

//# sourceMappingURL=index.js.map